<template>
    <restaurant-details-block
        class="restaurant-delivery-providers"
        title="delivery available from"
    >
        <div class="delivery-providers">
            <div
                v-for="provider in providers"
                :key="provider.name"
                class="provider"
            >
                <a
                    :href="provider.url"
                    target="_blank"
                    rel="noopener"
                    v-test:providerLink
                >
                    <span
                        class="sr-only"
                        v-test:a11yText
                    >
                        Order on {{ provider.name }}
                    </span>

                    <component
                        :is="provider.image"
                        v-test:providerImage
                    />
                </a>
            </div>
        </div>
    </restaurant-details-block>
</template>

<script>
    import RestaurantDetailsBlock from '../../molecules/RestaurantDetailsBlock/RestaurantDetailsBlock';

    /* eslint-disable @netsells/require-jsdoc-except/require-jsdoc */
    const DeliverooLogo = () => import('../../../assets/images/svgs/deliveroo-logo.svg?inline');
    const UberEatsLogo = () => import('../../../assets/images/svgs/uber-eats-logo.svg?inline');
    const JustEatLogo = () => import('../../../assets/images/svgs/just-eat-logo.svg?inline');
    /* eslint-enable @netsells/require-jsdoc-except/require-jsdoc */

    export default {
        name: 'restaurant-delivery-providers',

        components: {
            RestaurantDetailsBlock,
            DeliverooLogo,
            UberEatsLogo,
            JustEatLogo,
        },

        props: {
            deliverooUrl: {
                type: String,
                default: '',
            },

            uberEatsUrl: {
                type: String,
                default: '',
            },

            justEatUrl: {
                type: String,
                default: '',
            },
        },

        computed: {
            /**
             * Return the available providers.
             *
             * @returns {({image, name: string, url: string}|{image, name: string, url: string}|{image, name: string, url: string})[]}
             */
            providers() {
                return [
                    {
                        name: 'Deliveroo',
                        url: this.deliverooUrl,
                        image: DeliverooLogo,
                    },
                    {
                        name: 'UberEats',
                        url: this.uberEatsUrl,
                        image: UberEatsLogo,
                    },
                    {
                        name: 'JustEat',
                        url: this.justEatUrl,
                        image: JustEatLogo,
                    },
                ].filter(({ url }) => url);
            },
        },
    };
</script>

<style lang="scss" scoped>
    svg {
        height: 25px;
        width: auto;
        max-width: 100%;
        display: block;
        filter: grayscale(100%);
        transition: 0.15s;
    }

    .delivery-providers {
        display: flex;
        align-items: center;
        padding: 10px 0;
        margin: 0 -10px;
    }

    .provider {
        padding: 0 10px;
        width: 33.333%;

        &:nth-child(2) svg {
            margin: 0 auto;
        }

        &:nth-child(3):last-child svg {
            margin-left: auto;
        }
    }

    a:hover,
    a:focus-visible {
        svg {
            filter: grayscale(0);
        }
    }
</style>
